/**
 * Narwhalia backend
 * Swagger API docs for Narwhalia Backend application
 *
 * OpenAPI spec version: 0.9
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export class OwnerDto {
	constructor (
		/** ext user id of the owner */
		public id: string = '0',
		/** Name of the owner */
		public name: string = 'Narwhalia'
	){}
}